import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { FoodItemOutflowModel } from 'src/app/models/food-item-outflow.model'

@Component({
  selector: 'app-dialog-delete-outflow',
  templateUrl: './dialog-delete-outflow.component.html',
  styleUrls: ['./dialog-delete-outflow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogDeleteOutflowComponent {
  constructor (
    public dialogRef: MatDialogRef<DialogDeleteOutflowComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      outflow: FoodItemOutflowModel
    }
  ) {}

  onNoClick (): void {
    this.dialogRef.close()
  }
}
